import { ChevronLeft, Frown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

type Props = { title: string; message: string; url: string; btnTitle: string };

export default function ExpiredLink({ title, message, url, btnTitle }: Props) {
    return (
        <div className='w-full h-[80vh] flex flex-col gap-2 items-center justify-center rounded-md'>
            <div className='size-[48px]'>
                <Frown
                    size='48px'
                    className='animate-bounce text-red-500'
                />
            </div>
            <h2 className='text-xl tracking-[-0.16px] dark:text-[#fcfdffef] font-bold'>
                {title}
            </h2>
            <p className='mb-2 text-center text-sm text-muted-foreground dark:text-[#f1f7feb5] font-normal'>
                {message}
            </p>
            <Link to={url}>
                <Button
                    className='h-fit flex flex-col justify-center'
                    variant={'link'}>
                    <ChevronLeft className='!size-8 border-2 rounded-full' />
                    {btnTitle}
                </Button>
            </Link>
        </div>
    );
}
